import { ObjectId } from '@racemap/sdk/schema/base';
import { Modal, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';
import { useStore } from '../../store/reducers';
import { UserChooser } from '../BasicComponents/UserChooser';

const { Text } = Typography;

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ImpersonateUserModal = ({ open, onClose }: Props) => {
  const { impersonateUser } = useStore((s) => s.users.actions);
  // Populated by EventEditorView on /admin/events/:eventId and null everywhere
  // else, so an admin opening this from an event page starts on its creator.
  const currentEvent = useCurrentEvent();
  const suggestedUserId = currentEvent?.creatorId ?? null;
  const [userId, setUserId] = useState<ObjectId | null>(null);

  useEffect(() => {
    if (open) setUserId(suggestedUserId != null ? new ObjectId(suggestedUserId) : null);
  }, [open, suggestedUserId]);

  return (
    <Modal
      title="Impersonate user"
      open={open}
      onCancel={onClose}
      onOk={() => userId != null && impersonateUser(userId.toString())}
      okText="Impersonate"
      okButtonProps={{ disabled: userId == null }}
      destroyOnHidden
    >
      <Text type="secondary">
        You will see the app exactly as this user does. Impersonation is read-only — nothing can be
        changed while it is on.
      </Text>
      <div style={{ marginTop: 12 }}>
        <UserChooser value={userId} onChange={setUserId} autoFocus />
      </div>
    </Modal>
  );
};
